import ProductImage from "@/components/ProductImage";
import Reveal from "@/components/Reveal";
import Marquee from "@/components/Marquee";

const LOOKS = [
  { id: "look-1", angel: "222", image_url: "/img/look-01-cooler.webp", ratio: "aspect-[3/4]", tag: "LOOK 01 — COOLER LIGHT, 11:11 PM", caption: "222 Longsleeve / Bone", span: "lg:col-span-5" },
  { id: "look-2", angel: "222", image_url: "/img/look-02-backtoback.webp", ratio: "aspect-[3/4]", tag: "LOOK 02 — BACK TO BACK", caption: "222 Longsleeve / Onyx + Bone", span: "lg:col-span-5 lg:col-start-8 lg:mt-32" },
  { id: "look-3", angel: "222", image_url: "/img/look-03-brick.webp", ratio: "aspect-[3/4]", tag: "LOOK 03 — BRICK CORNER, AFTER MIDNIGHT", caption: "222 Longsleeve / Onyx + Bone", span: "lg:col-span-6 lg:col-start-4 lg:mt-10" },
];

export default function Lookbook() {
  return (
    <div data-testid="lookbook-page" className="pt-24">
      <section className="relative overflow-hidden px-5 pb-16 pt-10 sm:px-8">
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.35em] text-fade">CAMPAIGN 001 — SHOT ON LOCATION, LOS ANGELES</p>
          <h1 className="mt-4 font-display text-6xl font-extrabold uppercase leading-[0.9] tracking-tight text-bone sm:text-8xl">
            Look<span className="text-outline">book</span>
          </h1>
          <p className="mt-6 max-w-md text-base font-light leading-relaxed text-neutral-400">
            Clothing photographed where it actually gets worn — parking structures at 2am, empty intersections, the last train home. Places you end up on purpose.
          </p>
        </Reveal>
      </section>

      <section className="grid grid-cols-1 gap-6 px-5 sm:px-8 lg:grid-cols-12">
        {LOOKS.map((look, i) => (
          <Reveal key={look.id} delay={0.05 * i} className={look.span}>
            <figure data-testid={`lookbook-${look.id}`} className="group">
              <ProductImage product={look} ratio={look.ratio} tag={look.tag} />
              <figcaption className="mt-3 flex items-baseline justify-between">
                <span className="font-mono text-[10px] tracking-[0.25em] text-bone/70">{look.caption.toUpperCase()}</span>
                <span className="font-mono text-[10px] tracking-[0.25em] text-fade">{look.angel}</span>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </section>

      <div className="mt-24">
        <Marquee items={["SHOT ON LOCATION", "NO STUDIO. NO COINCIDENCES.", "CAMPAIGN 001"]} />
      </div>

      <section className="px-5 py-24 text-center sm:px-8">
        <Reveal>
          <p className="font-display text-2xl font-light italic tracking-tight text-neutral-300 sm:text-4xl">“You are where you're supposed to be.”</p>
          <p className="mt-6 font-mono text-[10px] tracking-[0.35em] text-fade">— CAMPAIGN 001, ALIGNDEPT</p>
        </Reveal>
      </section>
    </div>
  );
}
